<ng-template #notYetLoaded>
  @if ((service.configLoadErr$ | async) === null) {
    <p class="mt-2 mb-2">{{ 'savings-plan.saving-plans-confirm-config-items.loading' | transloco }}</p>
  }
</ng-template>
@if (service.config$ | async; as clientConf) {
  <hr class="less-margin" />
  @for (category of clientConf?.docCategories; track $index) {
    <ul class="list font-size-smaller2 mt-0" data-zid="client-config-docs">
      @for (doc of category?.docs; track $index) {
        @if (doc.assetsUrl && doc.assetsUrl.length) {
          <li>
            <a
              [href]="doc.assetsUrl"
              class="link-secondary"
              target="_blank"
              rel="noopener noreferrer"
              [innerHTML]="doc.title"
              [attr.aria-label]="doc.title"
            ></a>
          </li>
        } @else {
          <li [innerHTML]="doc.title"></li>
        }
      }
    </ul>
  }
} @else {
  <ng-container *ngTemplateOutlet="notYetLoaded" />
}
@if (service.configLoadErr$ | async) {
  <div class="d-flex justify-content-center mb-4 mt-4">
    <p class="text-danger">{{ service.configLoadErr$ | async }}</p>
    <web-design-system-button (click)="reloadConfig()" type="secondary" size="small" data-zid="client-config-reload-btn">
      {{ 'savings-plan.saving-plans-confirm-config-items.retry' | transloco }}
    </web-design-system-button>
  </div>
}
